
// Angular
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// Afidium
import { SearchComponent } from "./processing-search.component";


@NgModule({
    imports: [
        RouterModule.forChild([
            { path: '', pathMatch: 'full', component: SearchComponent },
        ]),
    ],
    exports: [
        RouterModule,
    ],
})
export class ProcessingSearchRouting {
}